import { styled as p } from "@mui/material";
import l from "../../share/apeiron/ApeironBlueButton.js";
import { useMessageContext as f } from "../../../contexts/share/MessageContext.js";
import { useCountDownTimer as u } from "../../../hooks/generic/useCountdownTimer.js";
import C from "../../../hooks/graphql/useSendOtpCode.js";
import { noForwardProps as w } from "../../../util/styled/index.js";
import { useCallback as _ } from "react";
import { useTranslation as g } from "react-i18next";
import { jsx as h } from "react/jsx-runtime";
const x = p(l, w)`
  width: 120px;
  height: 40px;

  &.Mui-disabled {
    color: ${(t) => t.__inCooldown ? "#ffffff" : "#777979"};
  }
`, P = (t) => {
  const {
    t: n
  } = g(), {
    email: e,
    disabled: a,
    otpType: c,
    cooldown: s = 60
  } = t, [o, r] = u(), {
    setSnackInfo: i
  } = f(), {
    mutate: m
  } = C(c), d = _(async () => {
    await m({
      email: e
    }), i({
      message: n("account_setting.otp_sent"),
      serverity: "success"
    }), r(s);
  }, [s, e, m, i, r, n]);
  return /* @__PURE__ */ h(x, {
    disabled: a || o > 0,
    __inCooldown: o > 0,
    onClick: d,
    children: o > 0 ? `${o}s` : n("account_setting.send_otp")
  });
};
export {
  P as default
};
//# sourceMappingURL=SendEmailOTPButton.js.map
